<template>
  <!--
    the value contains the to and from dates
    the to is disabled until the from date is given a value
    https://github.com/mengxiong10/vue2-datepicker
  -->
  <div class="date-from-to">
    <label>{{label}}</label>
    <div class="date-from-to__datepicker-container">
      <span class="date-from-to__datepicker-seperator">
        <datepicker
          lang="eng"
          :value="value.from"
          :not-before="fromNotBeforeDate"
          :not-after="fromEndDate"
          @input="changeFrom"
          :disabled="disableFrom || disableTo"
          :clear="e => changeFrom(null)"
          input-class="mx-input date-from-to__datepicker-input"
        />
      </span>
      <span>
        <datepicker
          lang="eng"
          :value="value.to"
          @input="changeTo"
          :disabled="!enableTo"
          :not-before="toStartDate"
          :clear="e => changeTo(null)"
          input-class="mx-input date-from-to__datepicker-input"
        />
      </span>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vue2-datepicker'

const OPTION_SETTINGS = {
  NORMAL: 1,
  ERASE_TO_WHEN_FROM_IS_CHANGED: 2,
  KEEP_TO_WHEN_FROM_IS_CHANGED: 3,
  CANT_CHANGE_FROM_PAST_TO: 4
}

export default {
  components: {
    Datepicker
  },
  props: {
    label: {
      type: String,
      default: null
    },
    value: {
      from: Date,
      to: Date
    },
    startDate: {
      type: Date,
      default: null
    },
    fromNotBeforeDate: {
      type: Date,
      default: ''
    },
    disableFrom: {
      type: Boolean,
      default: false
    },
    disableTo: {
      type: Boolean,
      default: false
    },
    startToDateFromToday: {
      type: Boolean,
      default: true
    },
    optionSetting: {
      type: Number,
      default: 1
    }
  },
  computed: {
    toStartDate () {
      if (this.value.from) {
        const today = new Date()
        today.setDate(today.getDate() + 1)
        today.setHours(0, 0, 0, 0)

        const nextFromDay = new Date(this.value.from)
        nextFromDay.setDate(this.value.from.getDate() + 1)

        if (this.startToDateFromToday) {
          if (today > this.value.from) {
            return today
          } else if (today === this.value.from) {
            today.setDate(today.getDate() + 3)
            return today
          } else {
            return nextFromDay
          }
        } else if (this.isOption3) {
          if (this.value.from > this.value.to) {
            return this.value.to
          } else {
            return nextFromDay
          }
        }
        return today
      } else {
        return this.value.to
      }
    },
    fromEndDate () {
      const previousToDate = new Date(this.value.to)
      if (this.isOption4 && (previousToDate.valueOf() !== 0 && this.value.to !== '')) {
        previousToDate.setDate(this.value.to.getDate() - 1)
        return previousToDate
      }
      return undefined
    },
    enableTo () {
      return this.value.from && !this.disableTo
    },
    isNormal () {
      return this.optionSetting === OPTION_SETTINGS.NORMAL
    },
    isOption2 () {
      return this.optionSetting === OPTION_SETTINGS.ERASE_TO_WHEN_FROM_IS_CHANGED
    },
    isOption3 () {
      return this.optionSetting === OPTION_SETTINGS.KEEP_TO_WHEN_FROM_IS_CHANGED
    },
    isOption4 () {
      return this.optionSetting === OPTION_SETTINGS.CANT_CHANGE_FROM_PAST_TO
    }
  },
  methods: {
    changeFrom (val) {
      if (this.isOption2) {
        this.$emit('input', {
          from: val,
          to: null
        })
      } else {
        this.$emit('input', {
          from: val,
          to: this.value.to
        })
      }
    },
    changeTo (val) {
      this.$emit('input', {
        from: this.value.from,
        to: val
      })
    }
  }
}
</script>

<style lang="scss">
.date-from-to {
  &__datepicker-container {
    display: flex;

    & > span {
      flex: 1;
    }

    .mx-datepicker {
      width: 100% !important;
      min-width: unset !important;

      .mx-datepicker-popup {
        position: fixed !important;
        left: unset !important;
        bottom: unset !important;
        top: unset !important;
        right: unset !important;
      }
    }
  }
  &__datepicker-seperator {
    margin-right: 10px;
  }
  &__datepicker-input {
    // width: unset !important;
    border-radius: unset !important;
  }
}

</style>



// WEBPACK FOOTER //
// DateFromTo.vue?5e06e221